export interface NSC_CALCULATOR_PROPS {
  principleAmount: number | undefined;
  interestRate: number | undefined;
  compoundFrequency: string | undefined;
}

export const NSC_CALCULATOR_FORMULA = ({
  principleAmount,
  interestRate,
  compoundFrequency,
}: NSC_CALCULATOR_PROPS) => {
  if (
    !principleAmount ||
    !interestRate ||
    !compoundFrequency ||
    Number(principleAmount) < 0 ||
    Number(interestRate) < 0 ||
    Number(compoundFrequency) < 0
  ) {
    return {
      maturityAmount: 0,
      resultPrincipalAmount: 0,
      interestEarned: 0,
    };
  }

  const compoundFrequencyFactor = compoundFrequency === 'semi-annually' ? 2 : 1;

  const maturityAmount =
    principleAmount *
    Math.pow(
      1 + interestRate / 100 / compoundFrequencyFactor,
      compoundFrequencyFactor * 5
    );

  const formattedMaturityAmount = Number(maturityAmount.toFixed(2));

  const interestEarned = formattedMaturityAmount - principleAmount;

  const formattedInterestEarned = Number(interestEarned.toFixed(2));

  return {
    maturityAmount: formattedMaturityAmount,
    resultPrincipalAmount: principleAmount,
    interestEarned: formattedInterestEarned,
  };
};
